/* eslint-disable arrow-body-style */
import { ajax } from '../ajax';
import { AjaxResponse } from '../ajax/types';
import { SelectOption } from '../types';

/* eslint-disable @typescript-eslint/no-use-before-define */
export async function fetchSelectOptions(
  url: string
): Promise<AjaxResponse<SelectOption[]>> {
  const { payload: payloadTentative, ...rest } = await ajax(
    {
      content: [],
    },
    url,
    {
      method: 'get',
    }
  );
  const payload = Array.isArray(payloadTentative.content)
    ? sanitizeSelectOptions(payloadTentative.content)
    : [];
  return {
    payload,
    ...rest,
  };
}

function sanitizeSelectOptions(items: SelectOption[]): SelectOption[] {
  return items
    .filter((item) => !!item)
    .map((item) => {
      return {
        label: item.label ?? '',
        value: item.value ?? '',
      };
    })
    .filter(beUniqueSelectOption);
}

export function beUniqueSelectOption(
  item: SelectOption,
  index: number,
  self: SelectOption[]
): boolean {
  return index === self.findIndex((t) => t.value === item.value);
}
